<template>
   <div class="breadcrumb">
       <span v-for="(item,index) in breadcrumb" :key="index">
           <span v-if="index != 0">&nbsp;/</span>
           <span v-if="index == breadcrumb.length -1">{{item.name}}</span>
           <span v-else style="cursor: pointer;"  @click="goRouter(item)">{{item.name}}</span>
       </span>
   </div>
</template>

<script>
export default {
    props:['breadcrumb'],
   data (){
       return {
           
       }
   },
   components: {
       
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       goRouter(item){
           this.$router.push({path:item.path});
       }
   },
   created() {
       
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.breadcrumb{
    color:#9EA7B4;
    font-size: 18px;
    font-weight: 500;
    line-height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/breadcrumb.vue